























































































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import {LoginState} from "../../store/modules/user";
import firebase from "firebase";
import LoginManager from "../../script/login";
import {helpers, maxLength, minLength, required, sameAs} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";

const emailValidator = helpers.regex(
    "emailValidator",
    /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
);

const pwdValidator = helpers.regex(
    "pwdValidator",
    /^(?=.*[a-zA-Z])((?=.*\d)|(?=.*\W)).{6,20}$/
);

@Component({
    components: {},
    mixins: [validationMixin],
    validations: {
        form: {
            email: {
                required,
                emailValidator,
            },
            password: {
                required,
                pwdValidator,
                minLength: minLength(6),
                maxLength: maxLength(20),
            },
            repeatPassword: {
                required,
                sameAsPassword: sameAs("password"),
            },
            username: {
                required,
                maxLength: maxLength(12),
            },
            // nickname: {
            //     required,
            //     maxLength: maxLength(20),
            //
            // },
        },
    },
})
export default class Login extends Vue {
    private form = {
        email: "",
        password: "",
        username: "",
        nickname: "",
        repeatPassword: "",
        policyAgreement1: false
    };
    isEmailReadOnly = false;
    isNameReadOnly = false;

    errorAgree1 = false;
    allAgreement = false;

    isDuplicatedNickname = false;

    async mounted() {
        const loginState = await this.$store.dispatch("loginState");

        switch (loginState) {
            case LoginState.login:
                await this.$router.replace("/").catch(() => {
                });
                return;
        }

    }


    beforeDestroy() {
        this.isEmailReadOnly = false;
        this.isNameReadOnly = false;
    }

    // vuelidate
    validateState(name) {
        const {$dirty, $error} = this.$v.form[name]!;
        return $dirty ? !$error : null;
    }
    @Watch('this.form.nickname')
    watchNickname(){
        if(this.form.nickname.length === 0)
        this.isDuplicatedNickname = false;
    }

    checkNickname(){
        this.$api.hasNickname(this.form.nickname)
        .then((res:any)=>{
            if(res.result === true){
                this.isDuplicatedNickname = true;
            }else{
                this.isDuplicatedNickname = false;
            }
        })
    }

    async register(event) {
        event.preventDefault();
        this.$v.form.$touch();
        let isReturn = false;
        if (this.$v.form.$anyError) {
            isReturn = true;
        }
        if (!this.form.policyAgreement1) {
            isReturn = true;
            this.errorAgree1 = true;
        }
        if(this.isDuplicatedNickname) {
            this.isDuplicatedNickname = true;
            isReturn = true;
        }

        if (isReturn) return;


        try {
            await firebase
                .auth()
                .createUserWithEmailAndPassword(
                    this.form.email,
                    this.form.password
                );
            const currentUser = firebase.auth().currentUser;
            const idToken = await currentUser!.getIdToken();

            this.$store.commit("idToken", idToken);

            this.joinZempie();

            // const obj={
            //     name:this.form.username,
            //     // nickname:this.form.nickname
            // }
            //
            // this.$api.signUp(obj)
            // .then(async (result:any)=>{
            //     const {user} = result;
            //     this.$store.commit("user", user);
            //     await LoginManager.login();
            //     // await this.$router.replace('/');
            //
            //     if (this.$store.getters.redirectRouter) {
            //         const router = this.$store.getters.redirectRouter;
            //         this.$store.commit("redirectRouter", null);
            //         await this.$router.replace(router).catch(() => {
            //         });
            //     }
            //     else if (this.$store.getters.redirectUrl) {
            //         const url = this.$store.getters.redirectUrl;
            //         this.$store.commit("redirectUrl", null);
            //         window.location.href = url;
            //     }
            //     else {
            //         await this.$router.replace("/").catch(() => {
            //         });
            //     }
            // })
            // .catch((result:any)=>{
            //     if (result?.error?.code === 40101) {
            //         alert("사용할 수 없는 이름입니다");
            //         // todo 닉네임 필터 에러 처리
            //         // alert(this.$t('join.joinNicknameError'));
            //     }
            //     else {
            //         console.error((result && result.error) || "error");
            //         result && result.error && alert(result.error.message);
            //     }
            // })

        }
        catch (error) {
            const code = error.code;
            if (code) {
                switch (code) {
                    case 'auth/wrong-password' :
                        alert(`${this.$t('wrong.pwd')}`)
                        break;
                    case 'auth/user-not-found' :
                        alert(`${this.$t('login.email.fail')}`)
                        break;
                    case 'auth/email-already-in-use':
                        const result = await this.$api.hasEmail(this.form.email)
                        if(result === true){
                            alert(`${this.$t('joined.email')}`)
                        }else{
                            this.joinZempie();
                        }
                        break;
                }
            }
        }
    }

    /**
     * zempie db 등록
     */
    joinZempie(){
        const obj={
            name:this.form.username,
            // nickname:this.form.nickname
        }

        this.$api.signUp(obj)
            .then(async (result:any)=>{
                const {user} = result;
                this.$store.commit("user", user);
                await LoginManager.login();
                // await this.$router.replace('/');

                if (this.$store.getters.redirectRouter) {
                    const router = this.$store.getters.redirectRouter;
                    this.$store.commit("redirectRouter", null);
                    await this.$router.replace(router).catch(() => {
                    });
                }
                else if (this.$store.getters.redirectUrl) {
                    const url = this.$store.getters.redirectUrl;
                    this.$store.commit("redirectUrl", null);
                    window.location.href = url;
                }
                else {
                    await this.$router.replace("/").catch(() => {
                    });
                }
            })
            .catch((result:any)=>{
                if (result?.error?.code === 40101) {
                    alert(`${this.$t('name.err.text')}`);
                    // todo 닉네임 필터 에러 처리
                    // alert(this.$t('join.joinNicknameError'));
                }
                else {
                    console.error((result && result.error) || "error");
                    result && result.error && alert(result.error.message);
                }
            })
    }

    agreement1() {
        if (this.form.policyAgreement1) {
            this.errorAgree1 = true;
        }
        else {
            this.errorAgree1 = false;
        }

    }

    allAgree() {
        if (this.allAgreement) {
            this.form.policyAgreement1 = false;
            // this.form.policyAgreement2 = false;
            this.errorAgree1 = true;
            // this.errorAgree2 = true;
        }
        else {
            this.form.policyAgreement1 = true;
            // this.form.policyAgreement2 = true;
            this.errorAgree1 = false;
            // this.errorAgree2 = false;
        }


    }


}
